// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable/Clickable";
import { IconWrapper } from "@insite/mobius/Icon/Icon";
import { navigationDrawerStyles } from "@keller/Overrides/Components/NavigationDrawer";
import { constants } from "@keller/XDL/constants";
import { buttonTransparent } from "@keller/XDL/PreStyle/button";
import { fontConfig } from "@keller/XDL/PreStyle/typography";
import color from "@keller/XDL/Utilities/color";
import xScreen from "@keller/XDL/Utilities/xScreen";
import { css } from "styled-components";

navigationDrawerStyles.menuTriggerButton = {
    shape: "pill",
    color: "secondary",
    css: css`
        padding: 6px;
        height: 36px;
        width: 36px;
        border-radius: 2px;
        ${xScreen("lte", "md")} {
            ${IconWrapper} {
                color: ${color("primary")};
            }
        }
        ${xScreen("lte", constants.navigationDrawer.breakpoints.md)} {
            ${IconWrapper} {
                color: ${color("common.white")};
            }
            &.expanded {
                &&& {
                    background-color: ${color("common.ui2")};
                }
            }
        }

        ${buttonTransparent}
    `,
};

navigationDrawerStyles.mainNavigationRow = {
    color: "common.white",
    css: css`
        margin: 2px;
        padding: 12px 14px;

        &:not(.first-depth-menu) {
            box-shadow: 0 1px 0 0 ${color("common.ui5")};
        }
    `,
};

navigationDrawerStyles.panelMenu = {
    cssOverrides: {
        wrapper: css`
            text-align: left;
            > a,
            button {
                height: 46px;
            }

            &:has(.first-depth-menu) {
                box-shadow: 0 1px 0 0 ${color("common.ui5")};
            }

            > ${StyledButton} {
                ${IconWrapper} {
                    width: fit-content;
                }
            }
        `,
    },
};

navigationDrawerStyles.signOutButton = {
    typographyProps: {
        size: 14,
        weight: fontConfig.weight.bold,
        transform: "uppercase",
    },
};
